import { FC, ReactElement } from 'react'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { customTooltipContentStyles } from './customTooltipContent.styles'

type CustomTooltipContentProps = {
  description?: string | null
  translationPlaceholders?: Record<string, string>
  tooltipContent?: ReactElement
  className?: string
}

const CustomTooltipContent: FC<CustomTooltipContentProps> = ({
  description,
  tooltipContent,
  translationPlaceholders,
  className = '',
}) => {
  const styles = customTooltipContentStyles()
  const intl = useIntl()
  const toolTipText = description
    ? intl.formatMessage({ id: description }, translationPlaceholders)
    : null

  let tooltipOutput = (
    <Typography
      component="span"
      dangerouslySetInnerHTML={{ __html: toolTipText || '' }}
      className={clsx(styles.tooltipContent, className)}
      variant="body2"
    />
  )

  if (!toolTipText && tooltipContent) {
    tooltipOutput = (
      <Typography
        component="span"
        className={clsx(styles.tooltipContent, className)}
        variant="body2"
      >
        {tooltipContent}
      </Typography>
    )
  }

  return (
    <Box component="span" data-test="common:mui:tooltip-content">
      {tooltipOutput}
    </Box>
  )
}

export default CustomTooltipContent
